// extracted by mini-css-extract-plugin
export default {"el":"styles_el__Q6uPR","info":"styles_info__YpiQ5","buttons":"styles_buttons__8s2qC","error":"styles_error__Wkxst"};